import { Box, Icon, Button } from "@mui/material";
import StripeLogo from "../../../assets/stripe.png";

type Props = {
  handleClick: () => void;
  loading: boolean;
};

const LinkToStripeButton = ({ handleClick, loading }: Props) => {
  return (
    <Button
      fullWidth
      startIcon={
        <Icon>
          <Box
            component="img"
            sx={{ width: "100%", verticalAlign: "top" }}
            src={StripeLogo}
            alt="Stripe Logo"
          />
        </Icon>
      }
      variant="contained"
      onClick={() => handleClick()}
      loading={loading}
      loadingPosition="start"
    >
      Link to Stripe
    </Button>
  );
};

export default LinkToStripeButton;
